import {action} from './actions.mjs';
import './assets/styles.css';
import './util/dom.js';
//import contentCmpt from './component/content/component.mjs';

document.body.innerHTML = '';
(async ()=>{
    const user = await action.who();
    const isLogin = !!user.data.token;
    const componentName = (isLogin) ? 'content' : 'login';

    //const componentName = 'content';
    const component = (await import(`./component/${componentName}/component.mjs`)).default;
    component.render();
})();
